import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesHeaderAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesHeaderAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_header_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesHeaderAction;
